import { Alert, AlertType } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SourcesUpdateAlertProps {
  updateType: 'update' | 'reset';
}

export const SourcesUpdateAlert = ({ updateType }: SourcesUpdateAlertProps) => {
  const { t } = useTranslation(['chat']);

  return (
    <Alert
      type={AlertType.Success}
      title={
        updateType === 'update'
          ? t('chat:trustedSources.updateSuccess')
          : t('chat:trustedSources.resetSuccess')
      }
    />
  );
};
